module.exports = __webpack_public_path__ + "static/img/space0.2d7951bc.png";